// extracted by extract-css-chunks-webpack-plugin
module.exports = {"backButton":"_2Go3yQ","button":"_28MV2j","closeButton":"h-9WLh","content":"_1MNmbP","navContainer":"_1B-GSb"};